import { SagaIterator } from "redux-saga";
import {ExcessMoneySettlementTypes, FetchExcessMoneySettlementByIdRequest, FetchExcessMoneySettlementRequest } from "./types";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { fetchExcessMoneySettlementApi, fetchExcessMoneySettlementsApi } from "./api";

function* fetchExcessMoneySettlements({ payload }: FetchExcessMoneySettlementRequest): SagaIterator {
    try {
        const response = yield call(fetchExcessMoneySettlementsApi, payload);
       
        yield put({
            type: ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENTS_SUCCESS,
            payload: { data: response.data.data }
        })
    } catch (error: any) {
        yield put({
            type: ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENTS_ERROR,
            payload: { error: error }
        })
    }
}

function* fetchExcessMoneySettlement({ payload }: FetchExcessMoneySettlementByIdRequest): SagaIterator {
    try {
        const response = yield call(fetchExcessMoneySettlementApi, payload);
        
        yield put({
            type: ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENT_SUCCESS,
            payload: { data: response.data.data }
        })
    } catch (error: any) {
        yield put({
            type: ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENT_ERROR,
            payload: { error: error }
        })
    }
}

export function* watchFetchExcessMoneySettlements() {
    yield takeEvery(ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENTS,fetchExcessMoneySettlements)
}

export function* watchFetchExcessMoneySettlement() {
    yield takeEvery(ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENT,fetchExcessMoneySettlement)
}

function* ExcessMoneySettlementSaga() {
    yield all([
        fork(watchFetchExcessMoneySettlements),
        fork(watchFetchExcessMoneySettlement)
    ])
}

export default ExcessMoneySettlementSaga;